/**
 * @deprecated Использовать isProductionOrIntegrationEnv из https://git.moscow.alfaintra.net/projects/NEWCLICK/repos/newclick-helpers/browse/src/utils/environment/guards.ts
 */
export const isProductionOrIntegrationEnv = (env) => ['production', 'integration'].includes(env);
/**
 * @deprecated Использовать isProductionEnv из https://git.moscow.alfaintra.net/projects/NEWCLICK/repos/newclick-helpers/browse/src/utils/environment/guards.ts
 */
export const isProductionEnv = (env) => env === 'production';
/**
 * @deprecated Использовать isIntegrationEnv из https://git.moscow.alfaintra.net/projects/NEWCLICK/repos/newclick-helpers/browse/src/utils/environment/guards.ts
 */
export const isIntegrationEnv = (env) => env === 'integration';
/**
 * @deprecated Использовать isDevelopmentEnv из https://git.moscow.alfaintra.net/projects/NEWCLICK/repos/newclick-helpers/browse/src/utils/environment/guards.ts
 */
export const isDevelopmentEnv = (env) => env === 'development';
